/**
 * What points at an entity, grouped by predicate and class, for the "Connected to" section.
 * Needs the SPARQL endpoint; signed-out visitors get status 'unavailable'.
 */

import { useEffect, useState } from 'react';
import { countIncoming, type IncomingGroup } from '@services/entityView.service';

export interface IncomingLinks {
  status: 'loading' | 'ready' | 'unavailable';
  groups: IncomingGroup[];
}

export function useIncomingLinks(uri: string): IncomingLinks {
  const [state, setState] = useState<IncomingLinks>({ status: 'loading', groups: [] });

  useEffect(() => {
    if (!uri) return;
    let cancelled = false;
    setState({ status: 'loading', groups: [] });
    countIncoming(uri)
      .then((groups) => !cancelled && setState({ status: 'ready', groups }))
      .catch(() => !cancelled && setState({ status: 'unavailable', groups: [] }));
    return () => {
      cancelled = true;
    };
  }, [uri]);

  return state;
}
